import React, { useEffect, useState } from 'react'
import { useLocation } from "react-router-dom"

import { Layout, Form, Input, Select, Card, Row, Col, Typography, Breadcrumb, Button } from 'antd'

import { useStore } from '../../contexts/FireStoreContext'
import countries from "../../data/countries"
import { getBaseUrl } from "../../utils/browser"
import UploadFile from "../../components/UploadFile"
const { Content } = Layout

const { Option } = Select

const table = "transactions"

const View = () => {
  const [form] = Form.useForm()
  const { updateDocument, getDocument } = useStore()
  const { state, pathname } = useLocation()
  const [file, setFile] = useState('')
  const [item, setItem] = useState('')
  const [working, setWorking] = useState(false)

  useEffect(() => {
    if (state.id) {
      getDocument(table, state.id).then(data => {
        console.log('getDocument', data)
        setItem(data)
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.id])

  const onFinish = data => {
    updateDocument(table, {
      agent: {
        comment: data.agent.comment,
      }
    }, state.id, "Comment", getBaseUrl(pathname))
    // console.log(data)
  }

  const onFinishFailed = data => console.log(data)

  console.log(state, item)

  return (
    <Content>
      <Breadcrumb>
        <Breadcrumb.Item>Transaction</Breadcrumb.Item>
        <Breadcrumb.Item>Edit</Breadcrumb.Item>
      </Breadcrumb>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        initialValues={item || state}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Card title="Sender Details">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    className="mb-2"
                    label="First Name"
                    name={['from', 'firstName']}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    className="mb-2"
                    label="Last Name"
                    name={['from', 'lastName']}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                className="mb-2"
                label="Country"
                name={['from', 'country']}
              >
                <Select
                  disabled
                  showSearch
                  placeholder="Select Country"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {countries?.map((option, i) => (
                    <Option key={i} value={option.code}>{option.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Amount"
                name='sendAmount'
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Reason"
                name='reason'
              >
                <Input.TextArea disabled />
              </Form.Item>
            </Card>
          </Col>
          <Col span={12}>
            <Card title="Recipient Details">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    className="mb-2"
                    label="First Name"
                    name={['to', 'firstName']}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    className="mb-2"
                    label="Last Name"
                    name={['to', 'lastName']}
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                className="mb-2"
                label="Country"
                name={['to', 'country']}
              >
                <Select
                  disabled
                  showSearch
                  placeholder="Select Country"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {countries?.map((option, i) => (
                    <Option key={i} value={option.code}>{option.name}</Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Amount"
                name="sendAmount"
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Bank"
                name={['to', 'bank']}
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Branch"
                name={['to', 'branch']}
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Account No"
                name={['to', 'accountNo']}
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Total Amount"
                name='totalAmount'
              >
                <Input disabled />
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Verification Attachments"
              // name={['from', 'docs']}
              >
                {item?.from?.docs?.map((doc, i) => (
                  <Typography.Link key={i} href={doc} target="_blank" rel="noreferrer">
                    {doc.split("/").pop().split("?")[0]}
                    {doc?.split("/")?.pop()?.split("?")[0]?.replace("docs%2F", "")}
                    <br />
                  </Typography.Link>
                ))}
              </Form.Item>
              <Form.Item
                className="mb-2"
                label="Comment"
                name='comment'
              >
                <Input.TextArea disabled />
              </Form.Item>
            </Card>
          </Col>

          <Col span={24}>
            <br />
            <Card title="Agent Area">
              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item
                    className="mb-2"
                    label="Attachment Document"
                  // name='agent.attachments'
                  >
                    <UploadFile
                      id={item.id}
                      table="transactions"
                      defaultFile={item.attachments}
                      file={file}
                      fieldName="attachments"
                      setFile={setFile}
                      working={setWorking}
                    // working={(status) => {
                    //   console.log("working", status)
                    //   setWorking(status)
                    // }}
                    />
                  </Form.Item>
                  <Form.Item
                    className="mb-2"
                    label="Agent Comment"
                    name={['agent', 'comment']}
                  >
                    <Input.TextArea />
                  </Form.Item>
                  <Form.Item className="pt-2">
                    <Row justify="end">
                      <Col>
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={working}
                        >
                          Update Comment
                        </Button>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Form>
    </Content>
  )
}

export default View
